// extracted by mini-css-extract-plugin
module.exports = {"about":"about_about__3VVYU","partners":"about_partners__34wbw","partnerTile":"about_partnerTile__3jQig"};